import { useEffect, useState } from 'react';

import { MediaWrapper } from '@/components/Cms/MediaWrapper';
import type { ContentfulImageWithFocalPointFragment } from '@/graphql/contentful/api';

import { parseSaleorProductSku } from '../../helpers';
import type { CardProps } from '../../types';

import * as S from './MediaAndWatchType.styles';
export const WatchImage = ({
  $backgroundAlignment,
  imgSrc,
}: {
  $backgroundAlignment: string;
  imgSrc: string;
}) => (
  <S.WatchImage
    $backgroundAlignment={$backgroundAlignment}
    alt='watch image'
    height={0}
    loading='eager'
    priority
    sizes='100%'
    src={imgSrc ?? ''}
    width={0}
  />
);
export const MediaAndWatchType = ({
  aspectRatio,
  backgroundAlignment,
  className,
  media,
  mediaAnimationEffect,
  mediaWrapperType,
  preload,
  saleorProductSku,
  visibleInDesktop,
  visibleInMobile,
}: CardProps) => {
  const [imgSrc, setImgSrc] = useState<string>('');
  useEffect(() => {
    const productData = parseSaleorProductSku(saleorProductSku);
    if (productData?.variant?.[0]?.node?.product?.media?.[0]?.url) {
      setImgSrc(productData?.variant?.[0]?.node?.product?.media?.[0]?.url);
    } else {
      setImgSrc('');
    }
  }, [saleorProductSku]);
  const $backgroundAlignment = backgroundAlignment ?? 'left';
  return (
    <S.Wrapper
      $visibleInDesktop={visibleInDesktop}
      $visibleInMobile={visibleInMobile}
      className={className}
      disableGutters
      maxWidth='xl'
    >
      {media?.image?.url && (
        <S.BackgroundMediaContainer
          $mediaAnimationEffect={
            mediaAnimationEffect === 'zoomOnHover' ? mediaAnimationEffect : null
          }
        >
          <S.Media $backgroundAlignment={$backgroundAlignment}>
            <MediaWrapper
              {...(media as ContentfulImageWithFocalPointFragment)}
              aspectRatio={aspectRatio}
              data-test-id='MediaAndWatchTypeBackgroundImage'
              mediaWrapperType={mediaWrapperType}
              preload={preload}
              sizes='(max-width: 600px) 50vw, 20vw'
              useAspectRatio={false}
            />
          </S.Media>
          {imgSrc && (
            <S.WatchWrapper $backgroundAlignment={$backgroundAlignment}>
              <S.StyledFlexItem />
              <S.WatchContainer $backgroundAlignment={$backgroundAlignment}>
                <WatchImage
                  $backgroundAlignment={$backgroundAlignment}
                  imgSrc={imgSrc}
                />
              </S.WatchContainer>
            </S.WatchWrapper>
          )}
        </S.BackgroundMediaContainer>
      )}
    </S.Wrapper>
  );
};
